import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    invoiceNumber: ""

}


const invoiceNumber = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

export default invoiceNumber;